import * as moment from "moment-timezone";
import { useCallback } from "react";

import {
  getDeliveryCutoff,
  getDeliveryWeekLeadTimes
} from "src/core/drops/utils/inherited-settings";
import { useDrop } from "src/core/drops/hooks";
import { IOrder } from "src/core/orders/api/orders.api";

import useOrderCutoffTime from "./useOrderCutoffTime";

/**
 * Check if an order is before cutoff
 *
 * @param {IOrder} order
 * @returns {(string | null)}
 */
const useOrderIsBeforeCutoff = () => {
  const [ { drop } ] = useDrop();
  const orderCutOffTime = useOrderCutoffTime();

  const isBeforeCutoff = useCallback(
    (order: IOrder, shortLong: "shortest" | "longest" = "shortest") => {
      if (!drop) {
        return false;
      }

      const weekLeadTimes = getDeliveryWeekLeadTimes(drop.groupedSettings);
      const defaultCutoff = getDeliveryCutoff(drop.groupedSettings);

      if (!weekLeadTimes || !defaultCutoff) {
        return false;
      }

      if (!order.orderDeliveryDate) {
        return true;
      }

      const cutoffTime = orderCutOffTime(order, shortLong);

      if (cutoffTime && moment.utc().isAfter(cutoffTime)) {
        return true;
      }

      if (order.amendmentExpiryDate && moment.utc().isAfter(order.amendmentExpiryDate)) {
        return true;
      }

      return false;
    },
    [ drop, orderCutOffTime ]
  );

  return isBeforeCutoff;
};

export default useOrderIsBeforeCutoff;
